import {
  limitedReleaseByVirtualConstants,
  createLimitedReleaseByVirtualConstants,
  editLimitedReleaseByVirtualConstants,
  activateLimitedReleaseByVirtualConstants,
  deactivateLimitedReleaseByVirtualConstants,
  deleteLimitedReleaseByVirtualConstants,
} from "../_redux-constants";
import { limitedReleasesVirtualService } from "../../_services";
import { errorExtractor } from "../../_helpers";

function getLimitedReleaseByVirtual(queryParams) {
  function getLimitedReleaseByVirtualLoad() {
    return {
      type: limitedReleaseByVirtualConstants.LIMITED_RELEASE_BY_VIRTUAL_LOADING,
    };
  }
  function getLimitedReleaseByVirtualSuccess(data) {
    return {
      type: limitedReleaseByVirtualConstants.LIMITED_RELEASE_BY_VIRTUAL_SUCCESS,
      data,
    };
  }
  function getLimitedReleaseByVirtualFailure(error) {
    return {
      type: limitedReleaseByVirtualConstants.LIMITED_RELEASE_BY_VIRTUAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getLimitedReleaseByVirtualLoad());
    return limitedReleasesVirtualService
      .getLimitedReleaseByVirtual(queryParams)
      .then(
        (data) => {
          dispatch(getLimitedReleaseByVirtualSuccess(data));
        },
        (error) => {
          dispatch(getLimitedReleaseByVirtualFailure(error?.toString()));
        }
      );
  };
}

function createLimitedReleaseByVirtual(requestBody, queryParams) {
  function createLimitedReleaseByVirtualLoad() {
    return {
      type: createLimitedReleaseByVirtualConstants.CREATE_LIMITED_RELEASE_BY_VIRTUAL_LOADING,
    };
  }
  function createLimitedReleaseByVirtualSuccess(data) {
    return {
      type: createLimitedReleaseByVirtualConstants.CREATE_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS,
      data,
    };
  }
  function createLimitedReleaseByVirtualFailure(error) {
    return {
      type: createLimitedReleaseByVirtualConstants.CREATE_LIMITED_RELEASE_BY_VIRTUAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(createLimitedReleaseByVirtualLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesVirtualService
        .createLimitedReleaseByVirtual(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(createLimitedReleaseByVirtualSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(createLimitedReleaseByVirtualFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function editLimitedReleaseByVirtual(requestBody, queryParams) {
  function editLimitedReleaseByVirtualLoad() {
    return {
      type: editLimitedReleaseByVirtualConstants.EDIT_LIMITED_RELEASE_BY_VIRTUAL_LOADING,
    };
  }
  function editLimitedReleaseByVirtualSuccess(data) {
    return {
      type: editLimitedReleaseByVirtualConstants.EDIT_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS,
      data,
    };
  }
  function editLimitedReleaseByVirtualFailure(error) {
    return {
      type: editLimitedReleaseByVirtualConstants.EDIT_LIMITED_RELEASE_BY_VIRTUAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editLimitedReleaseByVirtualLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesVirtualService
        .editLimitedReleaseByVirtual(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(editLimitedReleaseByVirtualSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(editLimitedReleaseByVirtualFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function activateLimitedReleaseByVirtual(queryParams) {
  function activateLimitedReleaseByVirtualLoad() {
    return {
      type: activateLimitedReleaseByVirtualConstants.ACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_LOADING,
    };
  }
  function activateLimitedReleaseByVirtualSuccess(data) {
    return {
      type: activateLimitedReleaseByVirtualConstants.ACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS,
      data,
    };
  }
  function activateLimitedReleaseByVirtualFailure(error) {
    return {
      type: activateLimitedReleaseByVirtualConstants.ACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(activateLimitedReleaseByVirtualLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesVirtualService
        .activateLimitedReleaseByVirtual(queryParams)
        .then(
          (data) => {
            dispatch(activateLimitedReleaseByVirtualSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(activateLimitedReleaseByVirtualFailure(error?.toString()));
            reject(error);
          }
        );
    });
  };
}

function deactivateLimitedReleaseByVirtual(queryParams) {
  function deactivateLimitedReleaseByVirtualLoad() {
    return {
      type: deactivateLimitedReleaseByVirtualConstants.DEACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_LOADING,
    };
  }
  function deactivateLimitedReleaseByVirtualSuccess(data) {
    return {
      type: deactivateLimitedReleaseByVirtualConstants.DEACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS,
      data,
    };
  }
  function deactivateLimitedReleaseByVirtualFailure(error) {
    return {
      type: deactivateLimitedReleaseByVirtualConstants.DEACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deactivateLimitedReleaseByVirtualLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesVirtualService
        .deactivateLimitedReleaseByVirtual(queryParams)
        .then(
          (data) => {
            dispatch(deactivateLimitedReleaseByVirtualSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              deactivateLimitedReleaseByVirtualFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function deleteLimitedReleaseByVirtual(queryParams) {
  function deleteLimitedReleaseByVirtualLoad() {
    return {
      type: deleteLimitedReleaseByVirtualConstants.DELETE_LIMITED_RELEASE_BY_VIRTUAL_LOADING,
    };
  }
  function deleteLimitedReleaseByVirtualSuccess(data) {
    return {
      type: deleteLimitedReleaseByVirtualConstants.DELETE_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS,
      data,
    };
  }
  function deleteLimitedReleaseByVirtualFailure(error) {
    return {
      type: deleteLimitedReleaseByVirtualConstants.DELETE_LIMITED_RELEASE_BY_VIRTUAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deleteLimitedReleaseByVirtualLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesVirtualService
        .deleteLimitedReleaseByVirtual(queryParams)
        .then(
          (data) => {
            dispatch(deleteLimitedReleaseByVirtualSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(deleteLimitedReleaseByVirtualFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

export const limitedReleasesVirtualActions = {
  getLimitedReleaseByVirtual,
  createLimitedReleaseByVirtual,
  editLimitedReleaseByVirtual,
  activateLimitedReleaseByVirtual,
  deactivateLimitedReleaseByVirtual,
  deleteLimitedReleaseByVirtual,
};
